"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimezoneLabel = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const date_fns_1 = require("date-fns");
const timezone_label_styles_1 = require("./timezone-label.styles");
const localization_1 = require("../../../localization");
const TimezoneLabel = () => {
    const { formatMessage: t, getLocale } = (0, localization_1.useLocalization)();
    const timezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const timeZoneDiff = new Date().getTimezoneOffset();
    const timezoneSign = timeZoneDiff <= 0 ? '+' : '-';
    const timezone = (0, date_fns_1.format)(Math.abs(timeZoneDiff), 'hh:mm');
    const shortTimezoneName = new Date()
        .toLocaleDateString(getLocale(), {
        day: '2-digit',
        timeZoneName: 'short',
    })
        .slice(4);
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const timezoneLabel = `${timezoneName} | ${t({
        key: 'PRODUCT_EDITOR_TABLE_TIMEZONE_LABEL',
    })} ${timezoneSign}${timezone} | ${shortTimezoneName}`;
    return (react_1.default.createElement(timezone_label_styles_1.StyledTimezoneLabel, null, react_1.default.createElement(ui_components_1.Typography, { variant: "caption" }, timezoneLabel)));
};
exports.TimezoneLabel = TimezoneLabel;
exports.default = exports.TimezoneLabel;
